import Animation from './Animation';
import React, { useCallback, useEffect, useRef } from 'react';
import { AnimationFullScreenWrapperStyled } from './styled/AnimationStyled';
import { LottieRefCurrentProps } from 'lottie-react';
import { useMakeSelector } from '../../hooks/useMakeSelector';
import { ANIMATION_EVENT_NAMES } from './animationConstants';
import { makeSelectShownAnimationsOnEventByName } from './animationSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { animationSlice } from './animationReducer';
import { getIsLocationPlatformDesktopSelector } from '../Location/locationSelectors';

function CloseAllAnimation() {
    const animationRef = useRef<LottieRefCurrentProps | null>(null);
    const isShowCloseAllAnimation = useMakeSelector(makeSelectShownAnimationsOnEventByName, [ANIMATION_EVENT_NAMES.CLOSE_ALL]);
    const isDesktop = useSelector(getIsLocationPlatformDesktopSelector);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isShowCloseAllAnimation) {
            animationRef.current?.play();
        }
    }, [isShowCloseAllAnimation]);

    const onCompleteHandler = useCallback(() => {
        animationRef.current?.stop();
        dispatch(animationSlice.actions.setIsShowAnimationOnEventAction({
            eventName: ANIMATION_EVENT_NAMES.CLOSE_ALL,
            isShow: false,
        }));
    }, [dispatch]);

    return <AnimationFullScreenWrapperStyled>
        <Animation
            autoplay={false}
            loop={false}
            lottieRef={animationRef}
            name={'ConfettiCloseAll'}
            onComplete={onCompleteHandler}
            renderer={'canvas'}
            rendererSettings={isDesktop ? undefined : { preserveAspectRatio: 'xMidYMid slice' }}
            style={{ width: '100%', height: '100%' }}
        />
    </AnimationFullScreenWrapperStyled>;
}

export default CloseAllAnimation;
